import { Component, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { CrewChangeServices } from '../../crew-change.service';
import { saveAs } from 'file-saver';
import { SharedModule } from 'src/app/shared/shared.module';
import { AuthenticationModule } from 'src/app/authentication/authentication.module';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-fleet-personnel-toolbar',
  templateUrl: './fleet-personnel-toolbar.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports:[SharedModule,
    AuthenticationModule,
    MatButtonModule,
  ],
})
export class FleetPersonnelToolbarComponent {

  constructor(private _router: Router,
              private _crewChangeService: CrewChangeServices,) {}

  addCrew() {
    this._router.navigate(['vessels/crew-change/crew']).then();
  }

  // addAppraisal() {
  //   this._router.navigate(['vessels/crew-change/appraisal']).then();
  // }

  downloadLatestStatusCrew() {
    this._crewChangeService.getLastExcelReport().subscribe(file => {
      const blob = file.body;
      if (blob) {
        saveAs(blob, 'crew-latest-status.xlsx');
      }
    });
  }

  downloadAllCrewChanges() {
    this._crewChangeService.getExcelReport().subscribe(file => {
      const blob = file.body;
      if (blob) {
        saveAs(blob, 'crew-changes.xlsx');
      }
    });
  }

  downloadCrew() {
    this._crewChangeService.downloadCrew().subscribe(file => {
      const blob = file.body;
      if (blob) {
        saveAs(blob, 'crews.xlsx');
      }
    });
  }
}
